interface DialpadProps {
  onDigit: (digit: string) => void;
}

const KEYS = [
  ['1', '2', '3'],
  ['4', '5', '6'],
  ['7', '8', '9'],
  ['*', '0', '#'],
];

const SUB_LABELS: Record<string, string> = {
  '2': 'ABC',
  '3': 'DEF',
  '4': 'GHI',
  '5': 'JKL',
  '6': 'MNO',
  '7': 'PQRS',
  '8': 'TUV',
  '9': 'WXYZ',
  '0': '+',
};

export function Dialpad({ onDigit }: DialpadProps) {
  return (
    <div className="grid grid-cols-3 gap-2">
      {KEYS.flat().map((key) => (
        <button
          key={key}
          type="button"
          onClick={() => onDigit(key)}
          className="flex flex-col items-center justify-center h-14 rounded-xl
                     bg-zinc-100 hover:bg-zinc-200 dark:bg-zinc-800 dark:hover:bg-zinc-700
                     transition-colors"
        >
          <span className="text-lg font-semibold text-zinc-900 dark:text-zinc-100">
            {key}
          </span>
          {SUB_LABELS[key] && (
            <span className="text-[9px] tracking-widest text-zinc-400 uppercase">
              {SUB_LABELS[key]}
            </span>
          )}
        </button>
      ))}
    </div>
  );
}
